(function () {
  const STORAGE_KEY = 'ci-wishlist.v1';

  function readWishlist() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      /* noop */
    }
  }

  function isFavorite(productId) {
    return readWishlist().some((item) => String(item.id) === String(productId));
  }

  function buildItem(toggle) {
    return {
      id: toggle.dataset.productId,
      handle: toggle.dataset.productHandle || '',
      title: toggle.dataset.productTitle || '',
      url: toggle.dataset.productUrl || '',
      image: toggle.dataset.productImage || '',
      vendor: toggle.dataset.productVendor || '',
      price: toggle.dataset.productPrice || '',
    };
  }

  function updateToggle(toggle, active) {
    const productTitle = toggle.dataset.productTitle || 'producto';
    toggle.classList.toggle('is-active', active);
    toggle.setAttribute('aria-pressed', String(active));
    toggle.setAttribute(
      'aria-label',
      `${active ? 'Quitar de favoritos' : 'Agregar a favoritos'}: ${productTitle}`
    );
  }

  function syncToggles(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-ci-favorite-toggle]').forEach((toggle) => {
      updateToggle(toggle, isFavorite(toggle.dataset.productId));
    });
  }

  function wishlistCountLabel(count) {
    if (count === 0) return 'Lista de deseos';
    if (count === 1) return 'Lista de deseos, 1 producto';
    return `Lista de deseos, ${count} productos`;
  }

  function syncWishlistCount() {
    const count = readWishlist().length;
    const countText = String(count);

    document.querySelectorAll('[data-ci-wishlist-count]').forEach((badge) => {
      badge.textContent = countText;
      badge.setAttribute('data-count', countText);
    });

    document.querySelectorAll('[data-ci-wishlist-link]').forEach((link) => {
      link.setAttribute('aria-label', wishlistCountLabel(count));
    });

    document.querySelectorAll('[data-ci-wishlist-mobile-link]').forEach((link) => {
      link.textContent = count === 0 ? 'Lista de deseos' : `Lista de deseos (${count})`;
    });
  }

  function toggleFavorite(toggle) {
    const productId = toggle.dataset.productId;
    if (!productId) return;

    const items = readWishlist();
    const itemIndex = items.findIndex((item) => String(item.id) === String(productId));
    let active = false;

    if (itemIndex >= 0) {
      items.splice(itemIndex, 1);
    } else {
      items.push(buildItem(toggle));
      active = true;
    }

    writeWishlist(items);

    document.querySelectorAll('[data-ci-favorite-toggle]').forEach((el) => {
      if (String(el.dataset.productId) === String(productId)) {
        updateToggle(el, active);
      }
    });

    syncWishlistCount();

    document.dispatchEvent(
      new CustomEvent('ci:wishlist:change', {
        detail: { items, productId, active },
      })
    );
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ci-favorite-toggle]');
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();
    toggleFavorite(toggle);
  });

  document.addEventListener('keydown', (event) => {
    const toggle = event.target.closest('[data-ci-favorite-toggle][role="button"]');
    if (!toggle) return;

    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    event.stopPropagation();
    toggleFavorite(toggle);
  });

  function syncAll(root) {
    syncToggles(root || document);
    syncWishlistCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll(document);
    });
  } else {
    syncAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    syncAll(event.target || document);
  });

  document.addEventListener('ci:product-grid:updated', function (event) {
    syncToggles((event && event.detail && event.detail.root) || document);
    syncWishlistCount();
  });

  document.addEventListener('ci:wishlist:change', syncWishlistCount);

  window.CIWishlist = {
    read: readWishlist,
    sync: syncToggles,
    syncCount: syncWishlistCount,
    storageKey: STORAGE_KEY,
  };
})();
